module.exports = __webpack_public_path__ + "img/controls_color.33989ffa.svg";